export const ENGLISH_PRODUCT_ID = "ILE";
export const SPANISH_PRODUCT_ID = "Spanish";

export function isValidProduct(productId){
    return productId === ENGLISH_PRODUCT_ID ||
        productId === SPANISH_PRODUCT_ID;
}


// WEBPACK FOOTER //
// ./src/constants/products.js